import { render } from "./AccionIncidenciaEntradaComponent.vue?vue&type=template&id=0d86893a&scoped=true"
import script from "./AccionIncidenciaEntradaComponent.vue?vue&type=script&lang=js"
export * from "./AccionIncidenciaEntradaComponent.vue?vue&type=script&lang=js"

import "./AccionIncidenciaEntradaComponent.vue?vue&type=style&index=0&id=0d86893a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d86893a"]])

export default __exports__